import React from 'react'
import styles from './Charm.module.css'
import CharmImages from './CharmImages'
import type { CharmImageItem } from './types'

const charmImages: CharmImageItem[] = [
    {
        src: '/pages/business/foodstadium/charm-image-1.png',
        alt: '業界特化 飲食特化の豊富な経験者層',
    },
    {
        src: '/pages/business/foodstadium/charm-image-2.png',
        alt: '求人掲載 無料で求人掲載「無制限」',
    },
    {
        src: '/pages/business/foodstadium/charm-image-3.png',
        alt: 'スカウト スカウトも無料で使い放題',
    },
    {
        src: '/pages/business/foodstadium/charm-image-4.png',
        alt: 'エージェント 困った時はプロと一緒に',
    },
    {
        src: '/pages/business/foodstadium/charm-image-5.png',
        alt: '掛け捨て0 成果型報酬で掛け捨てゼロ',
    },
    {
        src: '/pages/business/foodstadium/charm-image-6.png',
        alt: '便利機能 他にもサポート機能多数',
    },
]

export default function Charm() {
    return (
        <section id='charm' className={styles.charm}>
            <h1 className={styles.charmPc}>
                <img
                    src='/pages/business/foodstadium/charm-pc.svg'
                    alt='FoodsLaboの6つの魅力'
                />
            </h1>
            <h1 className={styles.charmSp}>
                <img
                    src='/pages/business/foodstadium/charm-sp.png'
                    alt='FoodsLaboの6つの魅力'
                />
            </h1>
            <div className={styles.charmBox}>
                <CharmImages images={charmImages} />
            </div>
        </section>
    )
}
